module.exports = __webpack_public_path__ + "static/media/newProcess2b.0ce73e36.png";